<template>
  <div class="right">
    <div class="title-box">
      <span class="curr">会议服务</span>
    </div>
    <div class="pt-30">
      <p>邀请国内外知名经济学家、国际政要、两院院士、诺贝尔奖得主、军事专家、专家学者、部委领导分析当前国内外经济形势，解读当前国家经济相关政策，在全国范围内举办经济论坛、高峰会、行业研讨会、大型活动以及系列专题讲座。</p>

      <p>通过组织论坛、专题考察、调研，搭建政府与企业，企业与企业之间的桥梁，促进政府与企业之间资源与资本的全面融合。</p>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      leftList: [
        '专家智库',
        '主要职责',
        '分会专家',
        '白皮书',
      ]
    }
  }
};
</script>
<style lang="less" scoped>

.right {
  width: 905px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  padding: 30px;
  p {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5F5F6A;
    line-height: 28px;
    margin-bottom: 40px;
    text-indent: 2em;
  }
}

.title-box {
  padding: 0 0 21px 0;
  border-bottom: 1px solid #f8f8fb;
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #909097;
    line-height: 28px;
    margin-right: 40px;
    position: relative;
    &.curr {
      color: #1b252c;
      &::after {
        width: 96px;
        height: 2px;
        background: #0d53bc;
        content: "";
        position: absolute;
        bottom: -20px;
        left: 0;
      }
    }
  }
}
</style>
